import { styled } from "@mui/material/styles";
import MainMenu from "./menu/MainMenu";

function AppSidebar(props) {
  const customTheme = null;

  const Sidebar = styled("div", {
    shouldForwardProp: (prop) => prop !== "alert",
  })(({ theme }) => ({
    position: "fixed",
    zIndex: 600,
    top: 65,
    backgroundColor:
      customTheme?.theme_id?.value === "custom_theme"
        ? customTheme?.body_bg
          ? customTheme?.body_bg
          : "#ffffff"
        : "#ffffff",
    marginTop: 0,
    height: "calc(100vh - 65px)",
    width: 72,
    overflowX: "hidden",
    overflowY: "auto",
    transitionDelay: ".2s,.2s,0s",
    transition: theme.transitions.create(
      ["background", "height", "width", "box-shadow"],
      {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      },
    ),

    "&::-webkit-scrollbar": {
      width: 4,
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "rgba(0, 0, 0, 0.10)",
      borderRadius: 10,
      transition: "background 0.2s ease",
    },
    "&:hover::-webkit-scrollbar-thumb": {
      background: "rgba(0, 0, 0, 0.18)",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "rgba(0, 0, 0, 0.30)",
    },

    scrollbarWidth: "thin",
    scrollbarColor: "rgba(0, 0, 0, 0.12) transparent",

    ":hover": {
      width: 200,
      background:
        customTheme?.theme_id?.value === "custom_theme"
          ? customTheme?.body_bg || "#ffffff"
          : "#ffffff",
      boxShadow: "1px 1px 12px #dadce0",
      "& .MuiListItemText-root": {
        display: "block !important",
      },
    },
  }));

  return (
    <Sidebar className="border-end" alert={props.alert ? props.alert : false}>
      <MainMenu />
    </Sidebar>
  );
}

export default AppSidebar;
